// @vendor
const moment = require('moment');
// @ actions
const { validateAndExecute } = require('actions/signaturePattern');
// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');

const {
    CANCEL_PENSION_PLAN_PENDING_ORDER_REQUEST,
    CANCEL_PENSION_PLAN_PENDING_ORDER_SUCCESS,
    CANCEL_PENSION_PLAN_PENDING_ORDER_FAILURE,

    BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_RESET,
    BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_SET_VISIBLE_STEP,
    BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_SHOW_CANCEL_MODAL,

    BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_VALIDATE_API_REQUEST,
    BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_VALIDATE_API_SUCCESS,
    BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_VALIDATE_API_FAILURE,
} = require('constants/contactCenter/actionTypes');

// Constants
const { WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, DATE_FORMAT_API, DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR } = require('constants/index');

const cancelPensionPlanPendingOrderInProgress = () => ({
    type: CANCEL_PENSION_PLAN_PENDING_ORDER_REQUEST
});

const cancelPensionPlanPendingOrderSuccess = payload => ({
    type: CANCEL_PENSION_PLAN_PENDING_ORDER_SUCCESS,
    payload
});

const cancelPensionPlanPendingOrderFailure = error => ({
    type: CANCEL_PENSION_PLAN_PENDING_ORDER_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_RESET
});

const setVisibleStep = step => ({
    type: BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const showCancelModal = (show) => ({
    type: BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

const validateWithAPIRequest = () => ({
    type: BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_VALIDATE_API_REQUEST
});

const validateWithAPISuccess = response => ({
    type: BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_VALIDATE_API_SUCCESS,
    payload: {
        response
    }
});

const validateWithAPIFailure = (error) => ({
    type: BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER_VALIDATE_API_FAILURE,
    payload: {
        error
    }
});

const validateWithAPI = (contractNumber, movementId, detailsIndex) => (dispatch, getState) => {
    const immBrokerContractActivities = getState().brokerContractActivities;

    const immMovement = immBrokerContractActivities.getIn([contractNumber, 'byId', movementId]);
    const immDetail = immMovement.getIn([
        'details',
        'data',
        'listaMovPendientesDet',
        'movPendienteDet',
        detailsIndex
    ]);
    const immcancelDetails = immDetail.get('cancelDetails');

    const requestData = {
        query: {
            producto: immMovement.get('productNumber'),
            numeroContrato: immMovement.get('contractNumber'),
            indSwitch: immcancelDetails.get('indSwitch'),
            numeroSecuencialOp: immDetail.get('numSecOpera'),
            codigoOperacion: immMovement.get('operationCode'),
            fechaSolScroll: moment(immDetail.get('fechSolScroll'), DATE_FORMAT_API).format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR),
        }
    };

    dispatch(validateWithAPIRequest());

    return APIGet({
        dispatch,
        endpoint: 'pensionPlanValidateCancelMovement',
        url: apiURLBuilder.getURL('pensionPlanValidateCancelMovement'),
        params: requestData
    })
    .then(response => {
        dispatch(validateWithAPISuccess(response));
        dispatch(setVisibleStep(WIZARD_SECOND_STEP));
    })
    .catch((error) => dispatch(validateWithAPIFailure(error)));
}

const validateStep = (step, contractNumber, movementId, detailsIndex) => (dispatch) => {
    if (step === WIZARD_FIRST_STEP) {
        dispatch(validateWithAPI(contractNumber, movementId, detailsIndex));
    }
};

const cancelPensionPlanPendingOrderRequest = (contractNumber, movementId, detailsIndex, dataToken) => (dispatch, getState) => {
    const {
        brokerPensionPlanCancelPendingOrder: immBrokerPensionPlanCancelPendingOrder,
        brokerContractActivities: immBrokerContractActivities
    } = getState();

    if (!immBrokerPensionPlanCancelPendingOrder.get('isFetching')) {

        dispatch(cancelPensionPlanPendingOrderInProgress());

        const immMovement = immBrokerContractActivities.getIn([ contractNumber, 'byId', movementId ]);
        const immDetails = immMovement.getIn([ 'details', 'data', 'listaMovPendientesDet', 'movPendienteDet', detailsIndex ]);

        const requestData = {
            query: {
                "codEstatus": immBrokerPensionPlanCancelPendingOrder.getIn( [ 'validationData', 'codEstatus' ]),
                "codigoProducto": immDetails.getIn([ 'cancelDetails', 'codigoProducto' ]),
                "codigoSubtipoProducto": immDetails.getIn([ 'cancelDetails', 'codigoSubtipoProducto' ]),
                "contratoSeleccionado": {
                    "numeroContrato": contractNumber,
                    "producto": immMovement.get('productNumber'),
                },
                "divisa": immDetails.getIn([ 'importe', 'divisa' ]),
                "fechaSolScroll": immDetails.getIn([ 'cancelDetails', 'fechaSolScroll' ]),
                "importe": immDetails.getIn([ 'importe', 'importe' ]),
                "indSwitch": immDetails.getIn([ 'cancelDetails', 'indSwitch' ]),
                "literalOpcion": immDetails.getIn([ 'cancelDetails', 'literalOpcion' ]),
                "nombreTitular": immDetails.getIn([ 'cancelDetails', 'nombreTitular' ]),
                "numeroSecuencialOP": immDetails.getIn([ 'cancelDetails', 'numeroSecuencialOp' ]),
                "planDescripcion": immDetails.getIn([ 'cancelDetails', 'planDescripcion' ]),
                dataToken
            }
        };

        return APIPost(dispatch, apiURLBuilder.getURL('pensionPlanCancelMovement'), requestData)
            .then(response => dispatch(cancelPensionPlanPendingOrderSuccess(response)))
            .catch(response => {
                if (response.error) {
                    return dispatch(cancelPensionPlanPendingOrderFailure(response.error));
                }
                throw response;
            });
    }
};

const cancelPensionPlanPendingOrder = (contractNumber, movementId, detailsIndex) => (dispatch, getState) => {
    validateAndExecute(dispatch, getState, (dispatch, getState, dataToken) => {
        dispatch(cancelPensionPlanPendingOrderRequest(contractNumber, movementId, detailsIndex, dataToken));
    });
}

module.exports = {
    cancelPensionPlanPendingOrder,
    setVisibleStep,
    validateStep,
    showCancelModal,
    reset
};
